import { Button, Tooltip, makeStyles, tokens } from '@fluentui/react-components'
import { CheckmarkCircle24Regular, Dismiss24Regular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  btn: {
    minWidth: 0,
    whiteSpace: 'nowrap',
  },
  iconBtn: {
    minWidth: '48px',
    whiteSpace: 'nowrap',
  },
})

export function ActionButtons({ onApprove, onReject, isLoading, iconOnly }: {
  onApprove: () => void
  onReject: () => void
  isLoading?: boolean
  iconOnly?: boolean
}) {
  const styles = useStyles()
  const { t } = useTranslation()
  const approveLabel = t('absences.actions.approve')
  const rejectLabel = t('absences.actions.reject')

  if (iconOnly) {
    return (
      <div className={styles.container}>
        <Tooltip content={approveLabel} relationship="label" positioning="above">
          <Button
            size="small"
            appearance="primary"
            icon={<CheckmarkCircle24Regular />}
            className={styles.iconBtn}
            disabled={isLoading}
            onClick={onApprove}
          />
        </Tooltip>
        <Tooltip content={rejectLabel} relationship="label" positioning="above">
          <Button
            size="small"
            appearance="secondary"
            icon={<Dismiss24Regular />}
            className={styles.iconBtn}
            disabled={isLoading}
            onClick={onReject}
          />
        </Tooltip>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <Button
        size="small"
        appearance="primary"
        icon={<CheckmarkCircle24Regular />}
        className={styles.btn}
        disabled={isLoading}
        onClick={onApprove}
      >
        {approveLabel}
      </Button>
      <Button
        size="small"
        appearance="secondary"
        icon={<Dismiss24Regular />}
        className={styles.btn}
        disabled={isLoading}
        onClick={onReject}
      >
        {rejectLabel}
      </Button>
    </div>
  )
}
